import MapView from '@arcgis/core/views/MapView';
import { MapPlugin } from '../../../shared/map/arcgis-types';
import { convertDataLayer } from '../../../shared/map/plugins/utils/layer-conversions';
import type { Layer } from '../../../models/layer-settings';

const FORM_RECORDS_LAYER_ID = 'photo-map-form-records';

/**
 * FormRecordsPlugin renders all records from the current app as a tile overlay,
 * using the same tile infrastructure as the data viewer.
 */
const FormRecordsPlugin = (dataLayer: Layer | undefined): MapPlugin => ({
  extendMap: (mapView: MapView): void => {
    if (!dataLayer || !mapView?.map) {
      return;
    }

    const arcLayer = convertDataLayer({ ...dataLayer, id: FORM_RECORDS_LAYER_ID });
    mapView.map.add(arcLayer);
  },
});

export default FormRecordsPlugin;
